export default "__VITE_ASSET__CinA_RGI__"